export const ACCOUNT_CONFIRM_STEP_STATUS_VALID = 'valid';
export const ACCOUNT_CONFIRM_STEP_STATUS_TODO = 'todo';
export const ACCOUNT_CONFIRM_STEP_STATUS_INPROGRESS = 'inprogress';
export const ACCOUNT_CONFIRM_STEP_STATUS_NONVERIFIED = 'nonverified';
export const ACCOUNT_LOADING_KEY = 'account-loading-key';
